import {
    ResponsiveContainer,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    Label,
    ComposedChart,
    Cell
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { formatGraphAxis, FertilizerLegend, FertilizerTooltip, formatTicker } from '../utils/graph-utils';
import { composedChartMargin, barGraphFontSize, labelOffSet, legendHeight, legendIconSize, responsiveContainerHeight, fertilizerColors, fertilizerLegendItems, fertilizerBarSize, chartOffset } from '../constants/graph-constants';

/**
 * 
 * @param {Object} props 
 * @param {{category: string, total: number, type: string}[]} props.data Graph data from backend
 * @param {string} props.type "Fertilizers Applied"
 * @param {string} props.group "Twee Jonge Gezellen"
 * @param {string} props.year "2024"
 * @param {string} props.unit This argument populates the Y axis with the corresponding unit value passed here.
 * @returns {JSX.Element} The facility's bar graph which displays an array of fertilizer items
 */

export default function FertilizerFacilityBarGraph({ data, type, group, year, unit }) {
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {group} {type} {year} per Facility
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <ComposedChart data={data} margin={composedChartMargin}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="category"
                        fontSize={barGraphFontSize}
                    >
                        <Label value="Fertilizer" position='insideBottom' offset={labelOffSet} fontSize={barGraphFontSize} />
                    </XAxis>
                    <YAxis
                        fontSize={barGraphFontSize}
                        domain={([dataMin, dataMax]) => { const yAxisDisplayMax = formatGraphAxis(dataMax, dataMin); return yAxisDisplayMax }}
                        tickFormatter={value => formatTicker(value)}
                    >
                        <Label value={unit} angle={-90} position={'insideLeft'} offset={chartOffset} fontSize={barGraphFontSize} />
                    </YAxis>
                    <Tooltip content={<FertilizerTooltip variant='facility' />} />
                    <Legend content={<FertilizerLegend legendItems={fertilizerLegendItems} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    <Bar
                        dataKey={'total'}
                        name={'Total'}
                        barSize={fertilizerBarSize}
                    >
                        {data?.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={fertilizerColors[entry.type] || '#ccc'}
                            />
                        ))
                        }
                    </Bar>
                </ComposedChart>
            </ResponsiveContainer>
        </Box>
    );
}